
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "PadelToast",
  methods: {
    emitClose() {
      this.$emit("close-clicked", true);
    },
  },
  props: {
    message: { type: String, required: false, default: "Error" },
    icon: { type: String, required: false, default: "warning" },
    type: { type: String, required: false, default: "error" },
  },
  emits: ["close-clicked"],
  setup(props, { emit }) {
    const { t, locale } = useI18n();
    /* COMPUTED */

    // SYSTEM

    return {
      t,
      locale,
    };
  },
});
